import { render, staticRenderFns } from "./ImportHistoryTable.vue?vue&type=template&id=24f68772"
import script from "./ImportHistoryTable.vue?vue&type=script&lang=ts"
export * from "./ImportHistoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports